/* eslint camelcase: 0 */
import common from './common/es_ES';
import confirmation from './confirmation/es_ES';
import dapps from './dapps/es_ES';
import header from './header/es_ES';
import home from './home/es_ES';
import footer from './footer/es_ES';
import gettingStarted from './getting-started/es_ES';
import privacyPolicy from './privacy-policy/es_ES';
import termsAndConditions from './terms-of-conditions/es_ES';
import createWallet from './create-wallet/es_ES';
import accessWallet from './access-wallet/es_ES';
import interfaceTranslations from './interface/es_ES';
import team from './team/es_ES';
import popover from './popover/es_ES';
import withoutWallet from './without-wallet/es_ES';
import errorsGlobal from './errors-global/es_ES';
import trezorError from './errors-trezor/es_ES';
import ledgerError from './errors-ledger/es_ES';
import secalotError from './errors-secalot/es_ES';
import keepkeyError from './errors-keepkey/es_ES';
import bitboxError from './errors-bitbox/es_ES';

const es_ES = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default es_ES;
